import axios from "axios";

// import authService from "../../components/api-authorization/AuthorizeService";
import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

export default function() {
    return (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());
        const { currentApplication } = getState();

        const updatedLicenceApplication = {
            id: Number(currentApplication.id),
            certificateTypeId: Number(currentApplication.certificateTypeId),
            certificateIssuedByOtherAdministration: currentApplication.certificateIssuedByOtherAdministration,
            certificateNumber: currentApplication.certificateNumber,
            salutationId: Number(currentApplication.salutationId),
            nameOnCertificate: currentApplication.nameOnCertificate,
            licenceApplicationStatusTypeId: 1,
            dateOfBirth: new Date(currentApplication.dateOfBirth) //.toISOString() //.toUTCString()
        };

        if (!isNaN(updatedLicenceApplication.dateOfBirth)) {
            var dob = updatedLicenceApplication.dateOfBirth;
            dob.setHours(4, 4, 4, 4);
            updatedLicenceApplication.dateOfBirth = dob.toISOString();
        }

        axios({
            method: "POST",
            url: "api/LicenceApplication/Submit",
            data: updatedLicenceApplication,
            withCredentials: true
        })
        .then((response) => {
            dispatch(CreateDataRetrievalEndedAction());
        })
        .catch((error) => {
            dispatch(CreateDataRetrievalEndedAction());
        });
    };
}
